import { render, staticRenderFns } from "./Friend.vue?vue&type=template&id=25ab21ad&"
import script from "./Friend.vue?vue&type=script&lang=js&"
export * from "./Friend.vue?vue&type=script&lang=js&"
import style0 from "./Friend.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports